import React from 'react';
import { Grid } from '@mui/material';
import type { Booking } from '../../../types/Booking.js';
import SupplierBookingCardItem from './SupplierBookingCardItem.js';
import { NoDataMessage } from '@securspace/securspace-ui-kit';
import { supplierHeaderCells } from './data.js';

const SupplierBookingCardList = (props: {bookings: Booking[], userIsAdmin: Boolean, handleSelectAdjustBooking: (booking: Booking, adjustType: {}) => {}, handleUpdatePendingBooking: () => {}}) => {
  const {bookings, rootStyle, userIsAdmin, handleSelectAdjustBooking, handleUpdatePendingBooking} = props;

  const imageURI =  "/app-images/person-and-box.svg";
  const message = "No matching bookings found"

  return (
    bookings.length?
      bookings.map((booking: Booking) => <SupplierBookingCardItem key={booking.id} booking={booking} headerCells={supplierHeaderCells} rootStyle={rootStyle} userIsAdmin={userIsAdmin} handleSelectAdjustBooking={handleSelectAdjustBooking} handleUpdatePendingBooking={handleUpdatePendingBooking} />)
      : <Grid item container>
        <NoDataMessage message={message} image={imageURI}/>
      </Grid> 
  );
}

export default SupplierBookingCardList;